// extracted by mini-css-extract-plugin
module.exports = {"badge":"Legend_badge__34Xih","orange":"Legend_orange__1GFV3","green":"Legend_green__22m2c","mr":"Legend_mr__2y8l7"};